import { FC, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { ChassisMarkFormInputs } from "./ChassisMarkFormInputs";
import { Button } from "../../../../../common/components/Button/Button";
import { useParams } from "react-router-dom";
import {
  useGetChassisMarkByIdQuery,
  useUpdateChassisMarkMutation,
} from "services/vehicle/chassisApi";
import { Error } from "common/components/Message/Error/Error";
import { getErrorMessage } from "common/utils/helpers";
import { Success } from "common/components/Message/Success/Success";

export const ChassisMarkEdit: FC = () => {
  const { id } = useParams();

  const {
    data: mark,
    isLoading: isMarkLoading,
    error: markError,
  } = useGetChassisMarkByIdQuery(id ? +id : -1, { skip: !id });

  const [update, { isLoading: isUpdating, error: updateError, isSuccess }] =
    useUpdateChassisMarkMutation();

  const methods = useForm<{
    name: string;
    id: number;
  }>();

  const {
    handleSubmit,
    reset,
    formState: { isDirty },
  } = methods;

  useEffect(() => {
    if (mark) {
      reset(mark);
    }
  }, [mark]);

  const onSubmit = handleSubmit((data) => {
    update(data);
  });

  if (markError || updateError) {
    return (
      <Error>{getErrorMessage(markError || updateError)?.data.message}</Error>
    );
  }

  if (isSuccess) {
    return <Success>Марка успешно отредактирована!</Success>;
  }

  return (
    <form className="grid gap-[15px]" onSubmit={onSubmit}>
      <FormProvider {...methods}>
        <ChassisMarkFormInputs />
      </FormProvider>
      <Button
        disabled={!isDirty || isUpdating || isMarkLoading}
        type="submit"
        className="w-fit"
      >
        Изменить
      </Button>
    </form>
  );
};
